import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
/** Components */
import Loader from '../../components/loader';
import { FormInput, FormButton } from '../../components/campo.js';
import { LogoPeque } from '../../logo';
/** Services */
import { getBuildings } from '../../utils/services/buildingService';
import { VisitorRegister } from '../../utils/services/visitorService';
import { validateMandatoryFields } from '../../utils/validator';
/** CSS */
import '../../index.css';
import { CONSTANS_DOCUMENT_TYPE } from '../../utils/enums';
import { showErrorAlert } from '../../utils/alerts';
import TerminosYCondiciones from '../../components/terminosYCondiciones';

export class FormApartmentExpressVisitorRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visitor: {
        cedula: '',
        documentType: 'CEDULA_CIUDADANIA',
        phone: '',
        photo: null,
        buildingId: '',
        acceptTerms: false,
      },
      previewPhoto: null,
      buildings: [],
      formData: null,
      errors: {},
      loading: false,
      documentTypes: CONSTANS_DOCUMENT_TYPE,
      showTermsModal: false,
    };
  }

  async componentDidMount() {
    try {
      const buildings = await getBuildings();
      const buildingId = buildings && buildings.length === 1 ? buildings[0].id : '';
      const formData = new FormData();

      this.setState({
        formData,
        buildings,
        visitor: {
          ...this.state.visitor,
          buildingId,
        },
      });
    } catch (error) {
      console.log(`componentDidMount -> error`, error);
    }
  }

  handleCloseTermsModal() {
    this.setState({
      showTermsModal: false,
    });
  }

  fixPhone = (phone) => `+57${phone.replace(/\s/g, '')}`;

  render() {
    const { previewPhoto, errors, visitor, loading, buildings, showTermsModal } = this.state;
    return (
      <div className="App bg-blue">
        <div className="container">
          <a onClick={this.goBack} className={'btn-back'} />
          <LogoPeque />
          <form onSubmit={this.handleSubmit.bind(this)} className="row d-flex w-75 mx-auto justify-content-between">
            <div className="foto-user mx-auto">
              <div>
                {previewPhoto && (
                  <img
                    src={previewPhoto}
                    style={{ borderRadius: '50%' }}
                    alt="Imagen usuario"
                    width="110px"
                    height="110px"
                  />
                )}
              </div>
              <input type="file" name="photo" id="photo" accept="image/*" onChange={this.handleImage} />
            </div>
            {errors.previewPhoto && (
              <div className="error-form-image-container">
                <span className="error-image">* Debes agregar la foto</span>
              </div>
            )}
            <div
              style={{
                fontSize: '1.3em',
                margin: '1em',
                color: '#FFFFFF',
              }}
              className="w-100 mx-auto"
            >
              Registro Rápido de Visitantes
            </div>
            <div className="skew-input input-shape w-100 mx-auto select">
              <select value={visitor.buildingId} name="buildingId" onChange={this.handleInputChange} id="buildingId">
                <option key="default_building" value="">
                  Selecciona un edificio
                </option>
                {buildings
                  .sort((buildingA, buildingB) => buildingA.name.localeCompare(buildingB.name))
                  .map((building) => (
                    <option key={building.id} value={building.id}>
                      {building.name}
                    </option>
                  ))}
              </select>
            </div>
            {errors.buildingId && (
              <div className="error-form-container">
                <span className="error-text">* Debes seleccionar un edificio</span>
              </div>
            )}
            <div className="skew-input input-shape-2 w-100 mx-auto select">
              <select
                value={visitor.documentType}
                name="documentType"
                onChange={this.handleInputChange}
                id="documentType"
                required
              >
                {Object.keys(this.state.documentTypes)
                  .sort((documentA, documentB) =>
                    this.state.documentTypes[documentA].localeCompare(this.state.documentTypes[documentB]),
                  )
                  .map((documentTypeKey) => (
                    <option key={documentTypeKey} value={documentTypeKey}>
                      {this.state.documentTypes[documentTypeKey]}
                    </option>
                  ))}
              </select>
            </div>
            <div className="skew-input w-100 mx-auto">
              <FormInput
                value={visitor.cedula || ''}
                onChange={this.handleInputChange}
                name="cedula"
                id="cedula"
                type="text"
                placeholder="# documento"
                required
              />
            </div>
            {errors.cedula && (
              <div className="error-form-container">
                <span className="error-text">* Debes diligenciar la cédula</span>
              </div>
            )}
            <div className="skew-input w-100 mx-auto">
              <FormInput
                value={visitor.phone || ''}
                onChange={this.handleInputChange}
                name="phone"
                id="phone"
                type="number"
                placeholder="Teléfono"
                required
              />
            </div>
            {errors.phone && (
              <div className="error-form-container">
                <span className="error-text">* Debes diligenciar el número de teléfono</span>
              </div>
            )}
            <div className="form-check">
              <input
                id="termsCheckbox"
                className="form-check-input"
                onChange={this.handleCheckboxChange}
                type="checkbox"
                name="acceptTerms"
                checked={visitor.acceptTerms || false}
              />
              <label className="form-check-label" htmlFor="termsCheckbox">
                He leido y acepto los
              </label>
            </div>
            <strong className="terms-condititions-link" onClick={() => this.setState({ showTermsModal: true })}>
              Términos y condiciones
            </strong>
            {showTermsModal ? <TerminosYCondiciones onModalClosed={this.handleCloseTermsModal.bind(this)} /> : null}
            {errors.acceptTerms && (
              <div className="error-form-container" style={{ marginTop: 0 }}>
                <span className="error-text">* Debes aceptar los términos y condiciones</span>
              </div>
            )}

            <div className="w-100 mx-auto d-flex justify-content-center">
              {loading ? (
                <Loader />
              ) : (
                <FormButton
                  type="submit"
                  value="Registrarse como Visitante"
                  textbutton="Registrarse como Visitante"
                  className="btn w-100 mx-auto button-form mt-1"
                />
              )}
            </div>

            <div className="col-sm-12 link-option-container">
              <span>¿ Es visitante frecuente ?</span>
              <div className="row w-100 text-form">
                <div className="col-sm-12">
                  <Link className="link-option" to="/apartment/visitor/register">
                    Regístro Visitante Frencuente
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  async handleSubmit(event) {
    this.setState({
      loading: true,
    });
    try {
      event.preventDefault();
      const { visitor, formData, previewPhoto } = this.state;
      const mandatoryFields = validateMandatoryFields({ ...visitor, previewPhoto }, [
        'cedula',
        'previewPhoto',
        'phone',
        'buildingId',
      ]);

      if (!visitor.acceptTerms) {
        mandatoryFields.acceptTerms = '* El campo es obligatorio';
      }

      this.setState({ errors: mandatoryFields });

      if (!Object.keys(mandatoryFields).length) {
        formData.set('name', visitor.name);
        formData.set('cedula', visitor.cedula);
        formData.set('documentType', visitor.documentType);
        formData.set('phone', this.fixPhone(visitor.phone));
        formData.set('buildingId', visitor.buildingId);

        const visitorRegistred = await VisitorRegister(formData);
        localStorage.setItem('userCedula', visitor.cedula);
        console.log('response', visitorRegistred);
        this.props.history.push('/visits/code');
      }
      this.setState({
        loading: false,
      });
    } catch (error) {
      console.log(`FormApartmentExpressVisitorRegister -> handleSubmit -> error`, error);
      this.setState({
        loading: false,
      });
      showErrorAlert('Ups', 'Hubo un error en el proceso de su registro.');
    }
  }

  handleInputChange = (event) => {
    this.setState({
      visitor: {
        ...this.state.visitor,
        [event.target.name]: event.target.value,
      },
    });
  };

  handleCheckboxChange = (event) => {
    const name = event.target.name;
    const newValue = !this.state.visitor[name];

    this.setState({
      visitor: {
        ...this.state.visitor,
        [name]: newValue,
      },
    });
  };

  handlePasswordChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      visitor: {
        ...this.state.visitor,
        [name]: value,
      },
    });
  };

  handleImage = async (event) => {
    let files = event.target.files;
    let reader = new FileReader();
    this.state.formData.set('photo', files[0]);
    reader.readAsDataURL(files[0]);
    reader.onloadend = () => {
      this.setState({
        previewPhoto: reader.result,
        formData: this.state.formData,
        visitor: {
          ...this.state.visitor,
        },
      });
    };
  };

  updateVisitorState = (name, value) => {
    this.setState({
      visitor: Object.assign({}, this.state.visitor, { [name]: value }),
    });
  };

  updateState = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  goBack() {
    window.history.back();
  }
}

FormApartmentExpressVisitorRegister.propTypes = {
  history: PropTypes.object,
};

export default FormApartmentExpressVisitorRegister;
